<template>
  <div id="app" :class="{ en: $i18n.locale == 'en' }">
    <Header v-show="$route && $route.meta && $route.meta.isHeader" />
    <router-view />
    <Footer v-show="$route && $route.meta && $route.meta.isFooter" />
    <RecommendDialog ref="recommendDialog" />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import RecommendDialog from '@/components/RecommendDialog.vue';
import getUrlAddressInfo from '@/utils/getUrlAddressInfo.js';
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    RecommendDialog
  },
  data() {
    return {
      urlInfo: {}
    };
  },
  mounted() {
    this.urlInfo = getUrlAddressInfo();
    if (this.urlInfo && this.urlInfo.recommendCode) {
      sessionStorage.setItem('recommendCode', this.urlInfo.recommendCode);
      this.$refs.recommendDialog.showModal = true;
    }
  },
  methods: {}
};
</script>

<style lang="less">
#app {
  height: 100vh;
}
// to fix 在ios设备中，el-select组件下拉框，点击2次才能选中问题。
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
